import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui";
import styles from "./StepFooter.module.css";

interface Props {
  onBack?: () => void;
  backLabel?: string;
  onContinue: () => void;
  continueLabel?: string;
  /** Show a spinner on the continue button. */
  loading?: boolean;
  /** Disable continue (e.g. background processing). */
  disabled?: boolean;
}

/**
 * Canonical Back/Continue row of every wizard step. Sits directly under the
 * step's content — never pinned to the viewport bottom — so the action is
 * always next to the question it answers. Back is a quiet in-flow link;
 * Continue is a normal-width primary button on the right.
 */
export function StepFooter({
  onBack,
  backLabel = "Back",
  onContinue,
  continueLabel = "Continue",
  loading = false,
  disabled = false,
}: Props): React.JSX.Element {
  return (
    <div className={styles.footer}>
      {onBack ? (
        <button
          type="button"
          onClick={onBack}
          disabled={loading}
          className={styles.back}
        >
          <ArrowLeft className={styles.backIcon} />
          {backLabel}
        </button>
      ) : (
        <span />
      )}
      <Button onClick={onContinue} loading={loading} disabled={disabled}>
        {continueLabel}
      </Button>
    </div>
  );
}
